import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTO_UPLOAD_STATUSES } from 'domains/seller-inventory-batch/constants'

const propTypes = {
  photo_upload_status: PropTypes.string
}

/**
 * To give nice look on Seller Inventory Batch Item `photo_upload_status`.
 * It maps `photo_upload_status` to certain style and pass to `StatusBadge`.
 * @param {string} photo_upload_status Seller Inbound Inventory Batch Items. available values
 * - `pending`
 * - `complete`
 */
const PhotoUploadStatusBadge = ({ photo_upload_status }) => {

  const colorMap = {
    [PHOTO_UPLOAD_STATUSES.PENDING]  : 'warning',
    [PHOTO_UPLOAD_STATUSES.COMPLETE] : 'success'
  }

  const color = colorMap[photo_upload_status]

  return <StatusBadge color={ color } label={ photo_upload_status } />
}

PhotoUploadStatusBadge.propTypes = propTypes

export default PhotoUploadStatusBadge